var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ListHeaderComponent',{attrs:{"background":_vm.background}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('EventHeaderComponent',{attrs:{"id":_vm.judgeID}}),_vm._v(" "),_c('DetailsComponent',{on:{"getJudgeID":_vm.getID}}),_vm._v(" "),_c('ContactComponent'),_vm._v(" "),_c('PartnersComponent')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-603277fb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Judge.vue
// module id = null
// module chunks = 